import autobind from 'autobind-decorator';
import * as React from 'react';
import ReactTextMask from '@blend/react-text-mask';

interface MaskedInputState {
  value: any;
  lastValue: any;
}

interface MaskedInputProps extends InputFormatterProps {
  inputProps: DirectInputProps;
}

@autobind
class MaskedInput extends React.Component<MaskedInputProps, MaskedInputState> {
  state = {
    value: '',
    lastValue: '',
  };

  constructor(props: MaskedInputProps) {
    super(props);

    this.state = {
      value: props.inputProps.value,
      lastValue: props.inputProps.value,
    };
  }

  updateValueWithHistory(nextValue) {
    this.setState({
      value: nextValue,
      lastValue: this.state.value,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateValueWithHistory(nextProps.inputProps.value);
  }

  handleChange(event) {
    const { normalize, inputProps } = this.props;
    const value = normalize(event.target.value);

    // Update the internal state to trigger a re-render
    // using the normalized value
    this.updateValueWithHistory(value);

    // Overwrite the value on the event so that the parent is notified with the normalized
    // value, but still gets the full event for additional context and the ability
    // to do things like stop propagation or default.
    event.target.value = value;
    inputProps.onChange(event);
  }

  render() {
    const { inputProps, format, mask } = this.props;
    // TODO (UI-2778): Revisit this branching to see if it can be refactored into something cleaner
    // e.g. if we remove the need for this component to handleChange itself and let redux-form do it
    // then the branch can probably be removed
    if (mask) {
      return <ReactTextMask {...mask} {...(inputProps as any)} />;
    }
    return (
      <input {...inputProps} value={format(this.state.value, this.state.lastValue)} onChange={this.handleChange} />
    );
  }
}

export default MaskedInput;
